import { arrayOfTimesGeneral } from '../../components/pages/Appointments/timeLines'

export const autoGenerateaptForm = ({ operation, patientId, patientName, multiplier, mainIssue, paidOperation, appointment_date, appointment_time, doctor_id, doctor_name }) => {
  const pricedata = Number(operation?.price)
  const hournow = new Date().getHours()
  let fromIdx = 0
  let fromObj, toObj
  
  if (appointment_time) {
    // Parse the time string to get decimal value (e.g., "09:30" -> 9.5)
    const [hours, minutes] = appointment_time.split(':').map(Number)
    const timeValue = hours + (minutes / 60)
    
    // Find the exact time slot in arrayOfTimesGeneral
    fromObj = arrayOfTimesGeneral.find((time) => time.value === timeValue) || arrayOfTimesGeneral[0]
    fromIdx = arrayOfTimesGeneral.findIndex((time) => time.value === timeValue)
    
    // Get the next time slot (30 minutes later)
    toObj = arrayOfTimesGeneral[fromIdx + 1] || arrayOfTimesGeneral[0]
  } else {
    fromObj =
      arrayOfTimesGeneral.find((time, idx) => {
        if (hournow === time.value) {
          fromIdx = idx
          return true
        }
        return false
      }) || arrayOfTimesGeneral[0]
    toObj = arrayOfTimesGeneral[fromIdx + 1] || arrayOfTimesGeneral[0]
  }

  const formObject = {
    date: appointment_date || new Date().toISOString().split('T')[0],
    from: appointment_time ? (Number(appointment_time.split(':')[0]) + Number(appointment_time.split(':')[1]) / 60) : fromObj.value,
    to: toObj.value,
    fromStr: fromObj.displayValue,
    toStr: toObj.displayValue,
    name: operation?.op_name || 'Untitled',
    category: operation?.category || 'N/A',
    operation_id: operation?.id || '',
    operation_name: operation?.op_name || '',
    color: operation?.color || '',
    description: mainIssue || 'Auto generated appointment',
    patient_id: patientId,
    patient_name: patientName || 'Anonymous',
    doctor_id: doctor_id || '',
    doctor_name: doctor_name || 'Dr. No Name',
    paid_amount: paidOperation ? pricedata : 0,
    unit_multiplier: multiplier || 1,
    price: pricedata,
    array_of_payments: paidOperation ? [{ date: appointment_date || new Date().toISOString().split('T')[0], amount: pricedata }] : [],
    is_paid: paidOperation,
    is_ongoing: false,
    init_date: new Date().toISOString()
  }
  return formObject
}
